/* CUSTOM: Seite hinter dem offenen Warenkorb-Drawer sperren, auch auf dem iPhone (komplett custom, Okt. 2026).
   Dawn sperrt die Seite nur per overflow: hidden am <body> (plus Sperre in assets/cart-compact.css).
   Safari auf dem iPhone haelt sich bei Fingerbewegungen nicht immer daran: Zog man z. B. im Kopf des
   Drawers ("Dein Warenkorb") oder auf der Abdunklung, scrollte manchmal die Seite dahinter mit.
   Deshalb wird, solange der Drawer offen ist (Klasse "active" an <cart-drawer>), jede Fingerbewegung
   abgebrochen, die nicht in einem Bereich beginnt, der selbst scrollen kann (Artikelliste, leerer Warenkorb
   mit Empfehlungen, Textfeld "Anmerkung", auf sehr kleinen Bildschirmen der ganze Drawer). Am Ende der Liste
   reicht overscroll-behavior: contain (assets/cart-compact.css) nichts an die Seite weiter.
   Zwei Finger (Zoomen) bleiben erlaubt. Der Listener haengt nur, solange der Drawer offen ist. */
(function () {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  let active = false;

  function canScroll(el) {
    const style = getComputedStyle(el);
    const scrollsY = (style.overflowY === 'auto' || style.overflowY === 'scroll') && el.scrollHeight > el.clientHeight + 1;
    return scrollsY || (el.tagName === 'TEXTAREA' && el.scrollHeight > el.clientHeight + 1);
  }

  function onTouchMove(event) {
    if (event.touches.length > 1) return;
    let el = event.target instanceof Element ? event.target : null;
    while (el && el !== drawer) {
      if (canScroll(el)) return;
      el = el.parentElement;
    }
    if (event.cancelable) event.preventDefault();
  }

  function sync() {
    const open = drawer.classList.contains('active');
    if (open === active) return;
    active = open;
    if (open) {
      document.addEventListener('touchmove', onTouchMove, { passive: false });
    } else {
      document.removeEventListener('touchmove', onTouchMove, { passive: false });
    }
  }

  new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  sync();
})();

/* CUSTOM (26.10.2026, Lisa: Knoepfe der Vorschlaege ragten in den "Glow" ueber den Gesamtkosten): Der weisse
   Schleier ueber dem Fussbereich zeigt nur noch an, dass unter ihm weitere Artikel kommen. Ist die Liste am Ende
   (oder passt alles), bekommt <cart-drawer> die Klasse jh-liste-ende und der Schleier blendet aus
   (assets/cart-compact.css). Dawn ersetzt den Drawer-Inhalt bei jeder Aenderung, deshalb wird bei jedem
   Neuaufbau, beim Oeffnen, nach geladenen Bildern und beim Scrollen neu geprueft. */
(function () {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  let geplant = false;

  function pruefen() {
    geplant = false;
    const liste = drawer.querySelector('cart-drawer-items');
    if (!liste) return;
    const ende = liste.scrollTop + liste.clientHeight >= liste.scrollHeight - 4;
    if (drawer.classList.contains('jh-liste-ende') !== ende) drawer.classList.toggle('jh-liste-ende', ende);
  }

  function planen() {
    if (geplant) return;
    geplant = true;
    setTimeout(pruefen, 50);
  }

  document.addEventListener(
    'scroll',
    function (event) {
      if (event.target instanceof Element && event.target.tagName === 'CART-DRAWER-ITEMS') planen();
    },
    true
  );
  drawer.addEventListener('load', planen, true);
  window.addEventListener('resize', planen);
  new MutationObserver(planen).observe(drawer, { childList: true, subtree: true });
  new MutationObserver(function () {
    planen();
    setTimeout(planen, 400);
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  planen();
})();
